import {getSVGIcon} from "../../../utilities/globalUtilities";

/**
 * Defines the HTML for the product swatches
 * @param {Object} product
 * @param {Object} resources
 */
const defineHTMLForProductSwatches = (product, resources, checkoutPage) => {
    let swatchesHTML = "";
    let swatchesName = "";
    const {variationAttributes} = product;

    if (!variationAttributes) {
        return swatchesHTML;
    }

    const colorList = variationAttributes.filter(element => {
        if (element.swatchable) {
            swatchesName = `
                <span class="${element.id} non-input-label mb-1">
                    ${element.displayName}
                </span>
            `;
        }

        return element.id == "color";
    });

    const colorObject = colorList.length ? colorList[0] : null;

    if (!colorObject) { return swatchesHTML; }

    swatchesHTML = `
        <div class="ct-pdp--variation-wrapper col-sm-auto" data-attr="${colorList ? "color" : ""}">
            <div class="attribute align-items-baseline flex-column">
                ${swatchesName}
                <div class="pwc-pdp--color-swatches d-flex pwc-mr--30 align-content-center">
    `;

    const {values, id: attrID} = colorObject;

    if (values && values.length) {
        values.forEach(element => {
            let {id: attrValueID, displayValue, images, selected, url, quickViewURL, selectable} = element;
            quickViewURL += checkoutPage ? "&cart=true" : "";
            let urlImage = images && images["swatch"] && images["swatch"].length > 0 ? images["swatch"][0].url : "";
            swatchesHTML += `
                <button class="quickview p-0 qv-swatch selectable color-attribute ct-pdp--color-variation ${selected ? "selected" : ""}"
                    data-attr-value="${attrValueID}"
                    data-id="${attrValueID}"
                    data-pdp-url="${url}"
                    data-url="${quickViewURL}"
                    href="${quickViewURL}">
                    <span class="swatch-circle--wrapper">
                        <span data-attr-value="${displayValue}"
                            class="${attrID}-value swatch-circle swatch-value ${selected ? "selected" : ""} ${selectable ? "selectable" : "unselectable"}"
                            style="background-image: url(${urlImage})"
                        >
                        </span>
                        ${getSVGIcon("icon-white-check")}
                    </span>
                    <span id="${attrValueID}" class="sr-only selected-assistive-text">
                        ${selected ? resources.assistiveSelectedText : ""}
                    </span>
                </button>
            `;
        });
    }

    swatchesHTML += `
                </div>
            </div>
        </div>
    `;

    return swatchesHTML;
};

/**
 * Defines the HTML for product sizes
 * @param {Object} product
 * @param {Object} resources
 * @param {String} brandID
 */
const defineHTMLForProductSizes = (product, brandID, checkoutPage) => {
    const {variationAttributes} = product;
    let sizeOptionsHTML = "";
    let defaultURL = "";

    if (!variationAttributes) {
        return sizeOptionsHTML;
    }

    const sizeList = variationAttributes.filter(element => { return element.id == "size"; });

    const sizeObject = sizeList.length ? sizeList[0] : null;

    if (!sizeObject) { return sizeOptionsHTML; }

    const {values, resetUrl} = sizeObject;
    defaultURL = resetUrl.replace("Variation", "ShowQuickView");

    if (values && values.length) {
        values.forEach(element => {
            let {displayValue, value, url, quickViewURL, selected, id} = element;
            quickViewURL += checkoutPage ? "&cart=true" : "";
            sizeOptionsHTML +=
                `<option class="selectable ${selected ? "selected" : ""}" ${selected ? "selected='selected'" : ""} value="${quickViewURL}" data-pdp-url="${url}" data-attr-value="${value}" data-variation-id="${id}">
                    ${displayValue}
                </option>
            `;
        });
    }

    const beginSizeSelectContainer = `
        <div class="ct-pdp--variation-wrapper mt-auto" data-attr="size">
            <div class="attribute">
                <div class="pwc-select-wrapper ${brandID}-select-wrapper ct-pdp--select-variation">
                    <label class="size visually-hidden" for="size-1">
                        ${sizeObject.displayName}
                    </label>
                    <select class="pwc-custom-select ${brandID}-custom-select selectable select-size js-quickview-sizes" id="size-1">
                        <option value="${defaultURL}">
                            ${sizeObject.displayName}
                        </option>
    `;

    const endSizeContainer = `
                    </select>
                    <i aria-hidden="true" class="search-arrow">
                        <span class="svg-wrapper svg-icon-arrow-down" style="width:auto; height:auto">
                            <svg class="svg-inline icon-arrow-down" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13" width="12" height="13"><path fill="#EB0203" fill-rule="evenodd" d="M5.406 9.174l-5.16-5.16a.84.84 0 111.189-1.188L6 7.39l4.565-4.565a.84.84 0 011.189 1.188l-5.16 5.16a.837.837 0 01-1.188 0z"></path></svg>
                        </span>
                    </i>
                </div>
            </div>
        </div>
    `;

    return [beginSizeSelectContainer, sizeOptionsHTML, endSizeContainer].join("");
};

/**
 * Defines the HTML for product sizes
 * @param {Object} product
 * @param {Object} resources
 */
const defineHTMLForVariationError = (product, resources) => {
    const {variationAttributes} = product;
    let variationErrorHTML = "";

    if (!variationAttributes) { return variationErrorHTML; }

    variationErrorHTML = `
        <div class="col-12">
            <span class="pwc-span-error ct-pdp--variation-error d-none">
                ${resources.variationError}
            </span>
            <span class="pwc-span-error ct-pdp--variation-error-add-favorite d-none">
                ${resources.variationErrorFavorite}
            </span>
        </div>
    `;

    return variationErrorHTML;
};

export { defineHTMLForProductSwatches, defineHTMLForProductSizes, defineHTMLForVariationError };
